import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { PageSection, HTMLParser } from '@gik/ui';
import withSuspense from '@gik/core/components/suspended/withSuspense';
import { useTerms } from '@gik/api/legal/legal';
import LegalSkeleton from './LegalSkeleton';

export const termsOfServiceBlockName = 'legal';

function TermsOfService(): React.ReactElement {
  const bem = bemBlock(termsOfServiceBlockName);
  const { data: termsArray, error: termsError } = useTerms();
  const terms = termsArray?.[0];

  const isLoading = !terms;
  const isError = isLoading && termsError;

  if (isLoading) return <LegalSkeleton />;
  if (isError) return <LegalSkeleton />;

  return (
    <PageSection className={bem()}>
      <HTMLParser rawHtml={terms.content.rendered} />
    </PageSection>
  );
}

export default withSuspense(TermsOfService, LegalSkeleton);
